import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServicejobsService } from './logic/servicejobs.service';
import { ServicejobsLogicService } from './logic/servicejobs/servicejobs-logic.service';
import { ServicejobsDaoService } from './dao/servicejobs-dao.service';
import { ServicejobsDbDaoService } from './dao/servicejobs-dao/servicejobs-db-dao.service';
import { ServicejobDbTableDefinition } from './dao/servicejobs-dao/servicejobs-db-table-definition';
import { LocalServicejobDbTableDefinition } from './dao/servicejobs-dao/local-servicejobs-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: ServicejobsService, useClass: ServicejobsLogicService },
    { provide: ServicejobsDaoService, useClass: ServicejobsDbDaoService },
    { provide: ServicejobDbTableDefinition },
    { provide: LocalServicejobDbTableDefinition },
  ]
})
export class ServicejobsModule {}
